import { Category } from './products'

export enum AuditType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  SEARCH = 'SEARCH',
  AUTH = 'AUTH',
}

export enum AuditAction {
  AUTH_LOGIN = 'AUTH_LOGIN',
  AUTH_LOGOUT = 'AUTH_LOGOUT',
  AUTH_LOGIN_FAIL = 'AUTH_LOGIN_FAIL',
  AUTH_PWD_CHANGE = 'AUTH_PWD_CHANGE',
  SEARCH_PRODUCT = 'SEARCH_PRODUCT',
  CREATE_VARIANT = 'CREATE_VARIANT',
  CREATE_PRODUCT = 'CREATE_PRODUCT',
  CREATE_USER = 'CREATE_USER',
  UPDATE_PRODUCT = 'UPDATE_PRODUCT',
  UPDATE_VARIANT = 'UPDATE_VARIANT',
  UPDATE_VARIANT_MOVE = 'UPDATE_VARIANT_MOVE',
  UPDATE_VARIANT_TAKE = 'UPDATE_VARIANT_TAKE',
  UPDATE_USER = 'UPDATE_USER',
  DELETE_PRODUCT = 'DELETE_PRODUCT',
  DELETE_VARIANT = 'DELETE_VARIANT',
  DELETE_USER = 'DELETE_USER',
}

export interface AuditEntityChange {
  field: string
  oldValue: string
  newValue: string
}

export interface AuditLog {
  id: string
  createdAt: string
  auditType: string
  auditAction: string
  user: { id?: string; fullName: string } | null
  product: { id?: string; symbol: string } | null
  variant: {
    id?: string
    category: Category
    place: string
    size: string
  } | null
  changes: Array<AuditEntityChange> | null
  metadata: Record<string, string> | null
}

export type AuditLogTableItem = Omit<AuditLog, 'createdAt'> & {
  createdAt: Date
}
